export default "__VITE_ASSET__CDMLHgkn__"